import request from '@/utils/request';
const baseURL = process.env.VUE_APP_SORTING;

/**
 * 新增规则组
 * @param {Object} data - 规则组信息
 * @param {string} data.groupName - 规则组名称
 * @param {number} data.machineId - 设备ID
 * @param {string} [data.description] - 描述
 * @returns {Promise}
 */
export function addRuleGroup(data) {
  return request({
    baseURL: baseURL,
    url: '/ruleGroup/add',
    method: 'post',
    data
  });
}

/**
 * 修改规则组
 * @param {Object} data - 规则组信息
 * @param {number} data.id - 规则组ID
 * @param {string} data.groupName - 规则组名称
 * @param {string} [data.description] - 描述
 * @returns {Promise}
 */
export function updateRuleGroup(data) {
  return request({
    baseURL: baseURL,
    url: '/ruleGroup/update',
    method: 'post',
    data
  });
}

/**
 * 启用规则组
 * @param {Object} params - 请求参数
 * @param {number} params.id - 规则组ID
 * @returns {Promise}
 */
export function enableRuleGroup(params) {
  return request({
    baseURL: baseURL,
    url: '/ruleGroup/enable',
    method: 'post',
    params
  });
}

/**
 * 失效规则组
 * @param {Object} params - 请求参数
 * @param {number} params.id - 规则组ID
 * @returns {Promise}
 */
export function disableRuleGroup(params) {
  return request({
    baseURL: baseURL,
    url: '/ruleGroup/disable',
    method: 'post',
    params
  });
}

/**
 * 分页查询规则组
 * @param {Object} data - 查询参数
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @param {Object} data.params - 筛选条件
 * @returns {Promise}
 */
export function getRuleGroupPage(data) {
  return request({
    baseURL: baseURL,
    url: '/ruleGroup/page',
    method: 'post',
    data
  });
}
